import { render, staticRenderFns } from "./juegosLibres.vue?vue&type=template&id=434ca478"
import script from "./juegosLibres.vue?vue&type=script&lang=js"
export * from "./juegosLibres.vue?vue&type=script&lang=js"
import style0 from "./juegosLibres.vue?vue&type=style&index=0&id=434ca478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports